import request from '@/util/request'

// 交易项目分页列表(招投标)
export function getInvitationList (data) {
    return request({
        method: 'post',
        url: '/api/invitationList',
        params: data
    })
}

// 交易项目详情（招投标）
export function getInvitationDetail (params) {
    return request({
        method: 'post',
        url: '/api/invitationDetail',
        params
    })
}

// 新增招投标报名
export function addInvitation (data) {
    request({
        method: 'post',
        url: '/transfer/auctionApply/addInvitation',
        data
    })
}